import { render, staticRenderFns } from "./ClinicSeg.vue?vue&type=template&id=c769ae58"
import script from "./ClinicSeg.vue?vue&type=script&lang=js"
export * from "./ClinicSeg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports